import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
  // attorney slider
  const teamSwiper = new Swiper('#meet-our-attorneys-id .meet-our-attorneys-swiper', {
    modules: [Navigation, Pagination, A11y],
    navigation: {
      nextEl: '#meet-our-attorneys-id .arrow-next',
      prevEl: '#meet-our-attorneys-id .arrow-prev',
    },
    loop: true,
    a11y: true,
    autoHeight: true,
    keyboardControl: true,
    grabCursor: true,
    watchOverflow: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // 992: {
      //   slidesPerView: 5,
      //   spaceBetween: 40,
      //   grabCursor: false,
      //   loop: false,
      //   allowTouchMove: false,
      // },
    },
  });
};
